import { Component, Input } from '@angular/core';

export interface Breadcrumb {
    title: string;
    route?: string[];
    queryParams?: Record<string, any>;
}

@Component({
    selector: 'breadcrumb',
    standalone: false,
    styleUrl: './breadcrumb.component.css',
    template: `
        <ol class="breadcrumb rounded bg-secondary-subtle d-print-none">
            <li class="breadcrumb-item" [ngClass]="{'active': last}" *ngFor="let item of items; last as last">
                <a [routerLink]="item.route" [queryParams]="item.queryParams" *ngIf="item.route">{{ item.title }}</a>
                <span *ngIf="!item.route">{{ item.title }}</span>
            </li>
        </ol>
    `
})
export class BreadcrumbComponent {

    @Input() items: Breadcrumb[];

}
